import AdminWebsocket from './AdminWebsocket';

class FlowDebuggerClient extends AdminWebsocket {
	connect() {
		return super.connect('/flows/debug');
	}

	start(flow, params, options) {
		this.sendData('start', { flow, params, options });
	}

	onRespond(listener) {
		this.onData('respond', listener);
	}

	unregisterEventListeners() {
		super.unregisterEventListeners();
		this.onRespond(null);
	}

	// NOTE: the flow overrides onError to additionally handle its own protocol errors.
	// Normal clients would not have to override.
	onError(listener) {
		if (!listener) {
			super.onError();
			this.onData('error');
			return;
		}

		this.onData('error', listener);
		super.onError(e => {
			// eslint-disable-next-line no-console
			console.error(e);
			listener(new Error('Websocket error occurred while debugging'));
		});
	}
}

export default FlowDebuggerClient;
